import { render } from "./ManualPayrunNoteWizard.vue?vue&type=template&id=b44e20c0"
import script from "./ManualPayrunNoteWizard.vue?vue&type=script&lang=js"
export * from "./ManualPayrunNoteWizard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__